<script>
 export let channel = "theconspiracyclub";
 // Generates a default pseudorandom listener handle
 let defaultNick = "childoferis_" + Math.floor(Math.random() * 899 + 100);
</script>

<div class="w-full h-[520px] border-2 border-black bg-stone-900 shadow-inner">
    <iframe
        src="https://web.libera.chat/?nick={defaultNick}#{channel}"
        class="w-full h-full border-0"
        style="border: 0; width: 100%; height: 100%; color-scheme: dark;"
        title="Radio Listener Chat"
        loading="lazy"
    ></iframe>
</div>
